// ENUMS #############################################################
export enum TenantEntityTooltipIdentifierEnum {
	ADDITIONAL_DATA = 'additionalData',
	BILLING_ADDRESS = 'billingAddress',
	CREATED_DATE = 'createdDate',
	CUSTOMER_IDENTIFIER = 'customerIdentifier',
	DESCRIPTION = 'description',
	LAST_MODIFIED_DATE = 'lastModifiedDate',
	NAME = 'name',
	STATUS = 'status',
	TENANT_TYPE = 'tenantType',
	VENDOR_CODE = 'vendorCode'
}

// CONSTANTS #########################################################


// TYPES #############################################################


// INTERFACES ########################################################
export interface ITenantEntityTooltipItem {
	identifier: TenantEntityTooltipIdentifierEnum;
}


// ENTITIES ##########################################################

